module.exports = __webpack_public_path__ + "img/thumbnail_SpectacledCaiman_j_normal.7615023b.png";